import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { VoterDataQueue } from '@/components/work-orders';

// The Voter data fulfilment queue. Platform-admin only and subsidiary-wide (every campaign's Paid
// orders), so it guards on the platform-admin role rather than a campaign capability; the API is
// the durable gate (403 for anyone else).
export const Route = createFileRoute('/admin/voter-data')({
  beforeLoad: ({ context }) => {
    requireRole(context, ['admin'], '/admin/voter-data');
  },
  component: VoterDataQueue,
});
